import { UserAuthForm } from "@/components/common/SignIn";
import Logo from "@/assets/img/logoC3Sgrand.jpeg";

export default function SignIn() {
  return (
    <div className="w-full h-screen flex">
      <div className="w-1/2">
        <img
          src={Logo}
          alt="Dashboard Icon"
          className="logo size-full rounded-md"
        />
      </div>
      <div className="w-1/2 h-full">
        <div className="w-full flex justify-center h-full">
          <UserAuthForm className="w-1/2 content-center" />
        </div>
      </div>
    </div>
  );
}
